import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
export const StyledSignupWithTextComponent = styled.div`
  width: 100%;
  position: relative;

  .signup-form-title {
    text-align: center;
    margin-bottom: 24px;

    h1 {
      font-weight: 500;
    }
  }

  &.with-subtitle {
    .signup-form-title {
      margin-bottom: 8px;
    }
  }

  &.text-under-buttons {
    .signup-form-subtitle {
      margin-bottom: 0;
      margin-top: 24px;
    }
  }

  .signup-form-subtitle {
    text-align: center;

    h2 {
      font-weight: 300;
    }

    margin-bottom: 24px;
  }

  .error-tooltip-text {
    color: red;
    font-weight: 300;
  }

  .tooltip {
    transform: translate(10%, -120%);
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .tooltip {
      transform: translate(5%, -120%);
    }
  }
`;
